import * as React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import SubPages from "../pages/subpages/SubPagesEnum";
import { logout } from '../shared/api/refreshAuth';
import { useAppNavigation } from '../hooks/useAppNavigation';
import { cn } from '../lib/utils';

export default function MainAppBar() {
  const navigateToPage = useAppNavigation();

  const handleLogoutClick = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div className="shrink-0 min-w-[310px]">
      <nav className="static bg-black h-[65px]">
        <div className="flex items-center h-full px-4">
          {/* Logo */}
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors"
            onClick={() => navigateToPage(SubPages.MyModels)}
            aria-label="Go to Models"
          >
            <img width="40" height="40" src="/logo-white-900.png" alt="Peerception logo" />
          </button>

          {/* Models */}
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors text-white"
            onClick={() => navigateToPage(SubPages.MyModels)}
            aria-label="Models"
          >
            <span className="material-symbols-outlined text-[32px] sm:hidden">architecture</span>
            <span className="hidden sm:block text-xl font-medium">Models</span>
          </button>

          {/* Portfolio */}
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors text-white"
            onClick={() => navigateToPage(SubPages.Portfolio)}
            aria-label="Portfolio"
          >
            <span className="material-symbols-outlined text-[32px] sm:hidden">account_balance_wallet</span>
            <span className="hidden sm:block text-xl font-medium">Portfolio</span>
          </button>
          {/* Library */}
          {process.env.REACT_APP_LIBRARY_ENABLED === 'true' && (
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors text-white"
            onClick={() => navigateToPage(SubPages.Library)}
            aria-label="Library"
          >
            <span className="material-symbols-outlined text-[32px] sm:hidden">library_books</span>
            <span className="hidden sm:block text-xl font-medium">Library</span>
          </button>
          )}

          {/* Organization */}
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors text-white"
            onClick={() => navigateToPage(SubPages.Organization)}
            aria-label="Organization"
          >
            <span className="material-symbols-outlined text-[32px] sm:hidden">groups</span>
            <span className="hidden sm:block text-xl font-medium">Organization</span>
          </button>

          {/* Contact */}
          <button
            className="mr-2 h-[50px] px-3 rounded-lg hover:bg-white/15 transition-colors text-white"
            onClick={() => navigateToPage(SubPages.Contact)}
            aria-label="Contact"
          >
            <span className="material-symbols-outlined text-[32px] sm:hidden">email</span>
            <span className="hidden sm:block text-xl font-medium">Contact</span>
          </button>

          {/* Spacer */}
          <div className="flex-grow" />

          {/* Profile Menu */}
          <Menu as="div" className="relative">
            {({ open }) => (
              <>
                <Menu.Button className="p-2 mr-1 hover:bg-white/15 rounded transition-colors text-white">
                  <span className="material-symbols-outlined text-[28px]">account_circle</span>
                </Menu.Button>

                <Transition
                  show={!!open}
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-none overflow-hidden z-50">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => navigateToPage(SubPages.MyAccount)}
                          className={cn(
                            'flex items-center w-full px-4 py-3 text-sm text-left gap-3',
                            active ? 'bg-slate-100 text-slate-900' : 'text-slate-700'
                          )}
                        >
                          <div className="w-8 h-8 rounded-full bg-slate-300 flex items-center justify-center">
                            <span className="material-symbols-outlined text-[20px] text-slate-600">
                              person
                            </span>
                          </div>
                          My account
                        </button>
                      )}
                    </Menu.Item>

                    <div className="border-t border-slate-200" />

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => navigateToPage(SubPages.Settings)}
                          className={cn(
                            'flex items-center w-full px-4 py-2 text-sm text-left gap-3',
                            active ? 'bg-slate-100 text-slate-900' : 'text-slate-700'
                          )}
                        >
                          <span className="material-symbols-outlined text-[18px]">settings</span>
                          Settings
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={handleLogoutClick}
                          className={cn(
                            'flex items-center w-full px-4 py-2 text-sm text-left gap-3',
                            active ? 'bg-slate-100 text-slate-900' : 'text-slate-700'
                          )}
                        >
                          <span className="material-symbols-outlined text-[18px]">logout</span>
                          Logout
                        </button>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </>
            )}
          </Menu>
        </div>
      </nav>
    </div>
  );
}
